import {formatImage} from 'components/formatos';

function IMAGEM(props){
    let BASEIMAGEM, CLASS;
    if(!props.src || props.src === '' || props.src === 'null' || props.src === 'undefined'){
       return null;
    }
    
    BASEIMAGEM = formatImage(props.src);
    if (!BASEIMAGEM) {
        return null;
    }

    if(props.className){
        CLASS = `rounded mx-auto d-block ${props.className}`;
    }else{
        CLASS = `rounded mx-auto d-block`;
    }

    return <img src={BASEIMAGEM} className={CLASS} width={props.width} alt={props.alt || ""} />
}

export default IMAGEM;